/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CityData } from '../models/city-data';
import { ListCitiesQuery } from '../models/list-cities-query';

@Injectable({
  providedIn: 'root',
})
export class CityService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation cityList
   */
  static readonly CityListPath = '/api/City/List';

  /**
   * Városok listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cityList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cityList$Plain$Response(params?: {
    body?: ListCitiesQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<CityData>>> {

    const rb = new RequestBuilder(this.rootUrl, CityService.CityListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CityData>>;
      })
    );
  }

  /**
   * Városok listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cityList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cityList$Plain(params?: {
    body?: ListCitiesQuery
  },
  context?: HttpContext

): Observable<Array<CityData>> {

    return this.cityList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<CityData>>) => r.body as Array<CityData>)
    );
  }

  /**
   * Városok listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cityList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cityList$Response(params?: {
    body?: ListCitiesQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<CityData>>> {

    const rb = new RequestBuilder(this.rootUrl, CityService.CityListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CityData>>;
      })
    );
  }

  /**
   * Városok listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cityList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cityList(params?: {
    body?: ListCitiesQuery
  },
  context?: HttpContext

): Observable<Array<CityData>> {

    return this.cityList$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<CityData>>) => r.body as Array<CityData>)
    );
  }

}
